import {
  createSlice,
} from "@reduxjs/toolkit";
import { Reducer } from "./Reducer";
import { ICodeListViewState } from "./Types";

const initialState: ICodeListViewState = {
  codeListView: {
    executionId: "",
    codeListId: "",
    codeListName: "",
    ruleName: "",
    artefactId: ""
  },
};

const Slice = createSlice({
  name: "code-list-view-reducer",
  initialState,
  reducers: Reducer,
});

export const { setCode, resetCode } = Slice.actions;

export default Slice;
